/**
 * Typ załączników
 *
 * @export
 * @enum {number}
 */
export enum AttachmentType {
  GENERATED = 'GENERATED',
  UPLOADED = 'UPLOADED'
}

/**
 * Typy załączników przetłumaczone do wyświetlania w historii
 *
 * @export
 * @enum {number}
 */
export enum AttachmentTypeTranslations {
  GENERATED = 'pisma',
  UPLOADED = 'załącznika'
}
